// extracted by mini-css-extract-plugin
export default {"buttonRow":"styles_buttonRow__LzK8U","templateButton":"styles_templateButton__mKE0S","buttonMargin":"styles_buttonMargin__COhv3","name":"styles_name__vev8e"};